module.exports = __webpack_public_path__ + "img/linkedin-logo.af08fb3d.svg";